import type { IParameters, ITariff } from '../models';

type TList = { [key: string]: string };

export const listFilter = (list: TList, values: string[]) => values.every(val => list[val]);

export const intervalFilter = ([left, right]: Array<string | number>, value: string | number) =>
    Number(value) >= Number(left) && Number(value) <= Number(right);

export const termFilter = (
    multiTermArray: Array<number | Record<string, unknown>>,
    value: string | number,
    goal: string[]
) => {
    /* Если любой элемент массива - объект, например 1-й, то логика с мультисроками */
    if (typeof multiTermArray[0] === 'object') {
        return multiTermArray.some(el => {
            const termInterval = Object.values(el).flat();

            const goalCondition = goal.every(i => Object.keys(i)[0] === i);

            return goalCondition && intervalFilter(termInterval, value);
        });
    }

    return intervalFilter(multiTermArray as [], value);
};

/** Фильтр свойств объекта выбранных пользователем параметров по допустимым параметрам  */
export const filterParameters = (data: ITariff[], currentParameters: IParameters) =>
    data.filter(({ acceptedParameters }) =>
        Object.entries(acceptedParameters).every(([key, values]) => {
            switch (key) {
                case 'amount':
                    return intervalFilter(values, currentParameters[key]);
                case 'term':
                    return termFilter(values, currentParameters[key], currentParameters.goal);
                case 'goal':
                    return listFilter(values, currentParameters[key]);
                default:
                    return false;
            }
        })
    );
